<template>
    <section>
        <o-menu label="Links">
            <o-menu-item
                label="Github"
                icon="link"
                tag="a"
                target="_blank"
                href="https://github.com/oruga-ui/" />
            <o-menu-item
                label="Documentation"
                icon="link"
                tag="a"
                target="_blank"
                href="/documentation/" />
        </o-menu>
    </section>
</template>
